import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SavePriceQuoteDocument = gql`
  mutation SavePriceQuote(
    $price_quote_id: uuid
    $chat_id: uuid!
    $name: String!
    $quote_type: String!
    $competitor_name: String
    $line_items: [SavePriceQuoteLineItemInput!]!
  ) {
    savePriceQuote(
      price_quote_id: $price_quote_id
      chat_id: $chat_id
      name: $name
      quote_type: $quote_type
      competitor_name: $competitor_name
      line_items: $line_items
    ) {
      price_quote_id
      name
      created_at
      updated_at
    }
  }
`;
export type SavePriceQuoteMutationFn = Apollo.MutationFunction<
  Types.SavePriceQuoteMutation,
  Types.SavePriceQuoteMutationVariables
>;
export function useSavePriceQuoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SavePriceQuoteMutation,
    Types.SavePriceQuoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SavePriceQuoteMutation,
    Types.SavePriceQuoteMutationVariables
  >(SavePriceQuoteDocument, options);
}
export type SavePriceQuoteMutationHookResult = ReturnType<
  typeof useSavePriceQuoteMutation
>;
export type SavePriceQuoteMutationResult =
  Apollo.MutationResult<Types.SavePriceQuoteMutation>;
export type SavePriceQuoteMutationOptions = Apollo.BaseMutationOptions<
  Types.SavePriceQuoteMutation,
  Types.SavePriceQuoteMutationVariables
>;
